import React, { Component } from 'react';
import NotificationItem from './NotificationItem';

export default class NotificationsChat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            notifications: this.props.notifications,
            selectedReceivers: this.props.selectedReceivers
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.selectedReceivers !== this.state.selectedReceivers){
            this.setState({selectedReceivers: nextProps.selectedReceivers});
        }
        if(nextProps.notifications !== this.state.notifications){
            this.setState({notifications: nextProps.notifications});
        }
    }

    handleSendNotification(){
        //отправить на сервер
        //добавить через редакс новый нотификейшн в список
        this.refs.textArea.value="";
    }

    render() {
        let items = [];
        let id = 1;
        let notifications = this.state.notifications;
        let notificationReceivers;
        let selectedReceivers = this.state.selectedReceivers;
        let nameWithLogin;
        for(let i = 0; i < notifications.length; i++){
            notificationReceivers = notifications[i].receivers;
            nameWithLogin = '';
            for(let j = 0; j < selectedReceivers.length; j++){
                for(let k = 0; k < notificationReceivers.length; k++){
                    if(notificationReceivers[k] === selectedReceivers[j]){
                        nameWithLogin += 'NAME (' + selectedReceivers[j] + '), ';
                    }
                }
            }
            if(nameWithLogin) {
                nameWithLogin = nameWithLogin.substring(0, nameWithLogin.length - 2);
                items.push(<NotificationItem key={id++} nameWithLogin={nameWithLogin} message={notifications[i].message}/>)
            }
        }

        return (
            <div className="chat-messages-window" style={{display: 'flex', overflow: 'auto', marginRight: 260, marginLeft: 260, marginTop: 20, flexDirection: 'column',
                justifyContent: 'flex-end', backgroundColor: '#ddd', minHeight: 300}}>
                {items}
                <div style={{display: 'flex'}}>
                <textarea ref={"textArea"} style={{height: 60, display: 'flex', width: '100%'}}/>
                    <button style={{fontSize: 17}} disabled={!this.state.selectedReceivers.length} onClick={this.handleSendNotification}>Отправить</button>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/notifictions/NotificationsChat.js